import { render, staticRenderFns } from "./ModelConfig.vue?vue&type=template&id=1d17cfc1&scoped=true&"
import script from "./ModelConfig.vue?vue&type=script&lang=js&"
export * from "./ModelConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d17cfc1",
  null
  
)

export default component.exports